import React from "react";
import { useDiagramDataV2 } from "./hooks/useDiagramDataV2";

export const DiagramXpressPlugV2 = () => {
  const data = useDiagramDataV2();
  const [scale, setScale] = React.useState(1);
  const containerRef = React.useRef(null);

  React.useEffect(() => {
    const calculateScale = () => {
      if (!containerRef.current) return;

      const container = containerRef.current;
      const viewportHeight = window.innerHeight;
      const viewportWidth = window.innerWidth;

      const contentHeight = container.scrollHeight;
      const contentWidth = container.scrollWidth;

      const scaleByHeight = (viewportHeight * 0.95) / contentHeight;

      const projectedWidth = contentWidth * scaleByHeight;

      let finalScale = scaleByHeight;
      if (projectedWidth > viewportWidth * 0.95) {
        finalScale = (viewportWidth * 0.95) / contentWidth;
      }

      setScale(finalScale);
    };

    setTimeout(calculateScale, 100);

    window.addEventListener("resize", calculateScale);
    return () => window.removeEventListener("resize", calculateScale);
  }, [data]);

  if (!data) {
    return null;
  }

  return (
    <div
      style={{
        width: "100%",
        height: "100vh",
        backgroundColor: "#ffffff",
        padding: "10px",
        boxSizing: "border-box",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        ref={containerRef}
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "10px",
          width: "fit-content",
          height: "fit-content",
          margin: "0 auto",
          alignItems: "flex-start",
          transform: `scale(${scale})`,
          transformOrigin: "center center",
          transition: "transform 0.3s ease",
        }}
      >
        {/* Main container */}
        <div
          style={{
            border: "2px solid #0b152F",
            borderRadius: "8px",
            backgroundColor: "#fff",
            padding: "30px",
            minWidth: "1600px",
            position: "relative",
            display: "flex",
            flexDirection: "row",
            alignItems: "flex-start",
            gap: "0px",
          }}
        >
          {/* Solution Ecosystem badge */}
          <div
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              padding: "8px 12px",
              backgroundColor: "#f0f0f0",
              borderRadius: "4px",
              fontSize: "12px",
            }}
          >
            <div
              style={{
                width: "24px",
                height: "24px",
                backgroundColor: "#416BA0",
                borderRadius: "4px",
              }}
            />
            <span style={{ color: "#000" }}>
              Solution
              <br />
              Ecosystem
            </span>
          </div>

          {/* Left side - Phone mockup */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "12px",
              flexShrink: 0,
              alignSelf: "flex-start",
            }}
          >
            <div
              style={{
                width: "200px",
                height: "400px",
                border: "4px solid #1a1a2e",
                borderRadius: "36px",
                backgroundColor: "#f8f9fa",
                position: "relative",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                overflow: "hidden",
                boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
                zIndex: 1,
              }}
            >
              {/* Notch */}
              <div
                style={{
                  position: "absolute",
                  top: "0px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: "100px",
                  height: "24px",
                  backgroundColor: "#1a1a2e",
                  borderRadius: "0 0 16px 16px",
                  zIndex: 2,
                }}
              />
              {/* Login screen content */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "100%",
                  flex: 1,
                  background: `linear-gradient(180deg, ${data.color1}22 0%, #ffffff 50%)`,
                }}
              >
                {/* Top bar area */}
                <div
                  style={{
                    width: "100%",
                    height: "32px",
                    flexShrink: 0,
                  }}
                />
                {/* Hero area - logo centered */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    flex: 1,
                    justifyContent: "center",
                    gap: "10px",
                    padding: "0 16px",
                  }}
                >
                  {data.logo && (
                    <img
                      src={data.logo}
                      alt={data.nombre}
                      style={{
                        width: "90px",
                        height: "70px",
                        objectFit: "contain",
                      }}
                      onError={(e) => {
                        e.target.style.display = "none";
                      }}
                    />
                  )}
                  <div
                    style={{
                      fontSize: "9px",
                      color: "#666",
                      textAlign: "center",
                      lineHeight: "1.4",
                      padding: "0 8px",
                    }}
                  >
                    Bank with confidence knowing
                    <br />
                    your money is protected.
                  </div>
                </div>
                {/* Buttons at bottom */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "10px",
                    width: "100%",
                    padding: "0 14px 24px",
                  }}
                >
                  {/* Veritran Xpress Plug label + dashed outline */}
                  <div
                    style={{
                      fontSize: "7px",
                      fontWeight: "600",
                      color: "#0b152F",
                      textAlign: "center",
                      letterSpacing: "0.3px",
                      marginBottom: "2px",
                    }}
                  >
                    Veritran Xpress Plug
                  </div>
                  <div
                    style={{
                      border: `2px dashed #0b152F`,
                      borderRadius: "12px",
                      padding: "5px",
                      width: "100%",
                    }}
                  >
                    <div
                      style={{
                        padding: "10px 8px",
                        border: "none",
                        borderRadius: "8px",
                        backgroundColor: data.color1,
                        color: "#fff",
                        fontSize: "10px",
                        fontWeight: "700",
                        textAlign: "center",
                        cursor: "default",
                      }}
                    >
                      Open an account
                    </div>
                  </div>
                  {/* Log in link */}
                  <div
                    style={{
                      color: data.color1,
                      fontSize: "10px",
                      fontWeight: "700",
                      textAlign: "center",
                      cursor: "default",
                    }}
                  >
                    Log in
                  </div>
                </div>
              </div>
              {/* Home indicator */}
              <div
                style={{
                  position: "absolute",
                  bottom: "8px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: "80px",
                  height: "4px",
                  backgroundColor: "#ccc",
                  borderRadius: "2px",
                }}
              />
            </div>
            <div
              style={{
                fontSize: "14px",
                fontWeight: "600",
                color: "#416BA0",
                textAlign: "center",
              }}
            >
              Customer Current App
            </div>
          </div>

          {/* Dashed 3-segment connection: Button → vertical → Onboarding Process */}
          <div
            style={{
              alignSelf: "flex-start",
              width: "60px",
              flexShrink: 0,
              position: "relative",
              zIndex: 2,
              marginLeft: "-10px",
              height: "400px",
            }}
          >
            {/* Top horizontal segment: enters Onboarding Process */}
            <div
              style={{
                position: "absolute",
                top: "15px",
                left: "0",
                width: "100%",
                borderTop: "2px dashed #0b152F",
              }}
            />
            {/* Vertical segment: connects top to bottom */}
            <div
              style={{
                position: "absolute",
                top: "15px",
                left: "0",
                height: "315px",
                borderLeft: "2px dashed #0b152F",
              }}
            />
          </div>

          {/* Right panel */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              flex: 1,
              gap: "10px",
            }}
          >
            {/* Onboarding Process */}
            {data.onboardingSteps && data.onboardingSteps.length > 0 && (
              <div
                style={{
                  border: "2px dashed #0b152F",
                  borderRadius: "8px",
                  backgroundColor: "#fafafa",
                  padding: "15px",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    fontSize: "12px",
                    fontWeight: "600",
                    marginBottom: "12px",
                    padding: "6px",
                    backgroundColor: "#416BA0",
                    color: "#fff",
                    borderRadius: "4px",
                    textAlign: "center",
                  }}
                >
                  Onboarding Process
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                    flexWrap: "wrap",
                  }}
                >
                  {data.onboardingSteps.map((step, index) => (
                    <React.Fragment key={index}>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "14px",
                          backgroundColor: "#fff",
                          borderRadius: "6px",
                          border: "1px solid #ddd",
                          minHeight: "120px",
                          minWidth: "120px",
                          maxWidth: "140px",
                        }}
                      >
                        <img
                          src={step.image}
                          alt={step.label}
                          style={{
                            width: "65px",
                            height: "65px",
                            marginBottom: "8px",
                            objectFit: "contain",
                          }}
                        />
                        <div
                          style={{
                            fontSize: "12px",
                            textAlign: "center",
                            color: "#333",
                          }}
                        >
                          {step.label}
                        </div>
                      </div>
                      {index < data.onboardingSteps.length - 1 && (
                        <div
                          style={{
                            fontSize: "18px",
                            color: data.color1,
                            fontWeight: "bold",
                          }}
                        >
                          →
                        </div>
                      )}
                    </React.Fragment>
                  ))}
                </div>
              </div>
            )}

            {/* Arrows between Onboarding and two-column section */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                padding: "5px 0",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "8px",
                  fontSize: "20px",
                  color: "#416BA0",
                  fontWeight: "bold",
                }}
              >
                <span>↓</span>
                <span>↑</span>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "8px",
                  fontSize: "20px",
                  color: "#416BA0",
                  fontWeight: "bold",
                }}
              >
                <span>↓</span>
                <span>↑</span>
              </div>
            </div>

            {/* Two-column layout: Veritran Components + Partner Ecosystem */}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: "20px",
              }}
            >
              {/* Veritran Components */}
              <div
                style={{
                  border: "2px dashed #0b152F",
                  borderRadius: "8px",
                  backgroundColor: "#fafafa",
                  padding: "15px",
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    fontSize: "12px",
                    fontWeight: "600",
                    marginBottom: "8px",
                    padding: "6px",
                    backgroundColor: "#416BA0",
                    color: "#fff",
                    borderRadius: "4px",
                    textAlign: "center",
                  }}
                >
                  Veritran Components
                </div>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(4, 1fr)",
                    gap: "8px",
                    marginTop: "5px",
                    overflow: "auto",
                    flex: 1,
                  }}
                >
                  {data.identityItems.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "10px",
                        backgroundColor: "#fff",
                        borderRadius: "4px",
                        border: "1px solid #ddd",
                        minHeight: "95px",
                      }}
                    >
                      <div
                        style={{
                          width: "50px",
                          height: "50px",
                          backgroundColor: item.color || "#0078D4",
                          borderRadius: "4px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "#fff",
                          fontSize: "18px",
                          fontWeight: "bold",
                          marginBottom: "8px",
                        }}
                      >
                        {item.iconName.substring(0, 2).toUpperCase()}
                      </div>
                      <div
                        style={{
                          fontSize: "11px",
                          textAlign: "center",
                          color: "#333",
                        }}
                      >
                        {item.label}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Partner Ecosystem */}
              <div
                style={{
                  border: "2px dashed #0b152F",
                  borderRadius: "8px",
                  backgroundColor: "#fafafa",
                  padding: "15px",
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    fontSize: "12px",
                    fontWeight: "600",
                    marginBottom: "8px",
                    padding: "6px",
                    backgroundColor: "#416BA0",
                    color: "#fff",
                    borderRadius: "4px",
                    textAlign: "center",
                  }}
                >
                  Partner Ecosystem
                </div>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(4, 1fr)",
                    gap: "12px",
                    marginTop: "5px",
                    overflow: "auto",
                    flex: 1,
                    alignContent: "flex-start",
                  }}
                >
                  {data.systemHealthItems.map((item, index) => (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "10px",
                        backgroundColor: "#fff",
                        borderRadius: "4px",
                        border: "1px solid #ddd",
                        minHeight: "70px",
                        maxHeight: "80px",
                      }}
                    >
                      <img
                        src={item.logoPath}
                        alt={item.name}
                        style={{
                          width: "auto",
                          height: "auto",
                          objectFit: "contain",
                          maxHeight: "50px",
                          maxWidth: "100%",
                        }}
                        onError={(e) => {
                          if (
                            e.target.src === item.logoPath &&
                            item.logoPathJpg
                          ) {
                            e.target.src = item.logoPathJpg;
                          } else if (
                            e.target.src === item.logoPathJpg &&
                            item.logoPathWebp
                          ) {
                            e.target.src = item.logoPathWebp;
                          } else {
                            e.target.style.display = "none";
                          }
                        }}
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
